<template>
  <div class="max-h-screen flex flex-row">
    <div
      class="transition-all duration-300 ease-in-out"
      :style="{ width: isSideBarExpanded ? '16.666667%' : '4%', zIndex: isPageHome ? 10 : 0 }"
    >
      <side-bar
        @toggle="onToggleSidebar"
      />
    </div>
    <div
      class="flex flex-col bg-background transition-all duration-300 ease-in-out"
      :style="{ width: isSideBarExpanded ? '83.333333%' : '96%' }"
    >
      <top-bar :class="{'z-10': isPageHome}" />
      <router-view class="h-screen overflow-auto" />
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/sideBar'
import TopBar from '@/components/topBar'
import store from '@/store'
import { isUserCanAccessFeature } from '@/utils/permissionUtils'

export default {
  components: {
    SideBar,
    TopBar
  },
  data() {
    return {
      isSideBarExpanded: true
    }
  },
  watch: {
    $route:{
      handler() {
        const havePermission = isUserCanAccessFeature()
        if(!havePermission.haveAccess) {
          return this.$router.push({ name: 'NotFound' })
        }
      },
      immediate: true
    }
  },
  computed: {
    isPageHome() {
      return this.$route.name === 'Home' || this.$route.name === 'RealTimeTracking'
    }
  },
  methods: {
    onToggleSidebar(state) {
      this.isSideBarExpanded = state
    }
  }
}
</script>

<style lang="scss" scoped>
.base-bg {
  background-color: #F1EFFA;
}
</style>
